import React, { useEffect, useState } from 'react';
import { Menu, X, MessageCircle } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'El Problema',
    href: '#problema'
  }, {
    name: 'La Solución',
    href: '#solucion'
  }, {
    name: 'Sobre Mí',
    href: '#sobre-mi'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-dark/90 backdrop-blur-md border-b border-white/5 py-3' : 'bg-transparent py-5'}`} data-id="element-183">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <div className="flex items-center justify-between" data-id="element-185">
          <a href="#" className="flex-shrink-0" data-id="element-186">
            <img src="https://cdn.magicpatterns.com/uploads/eY95HHpeUWzLiFnJXNd6yt/doado_logoor_ector.png" alt="Nacho Gomez Logo" className="h-14 md:h-16 w-auto object-contain" data-id="element-187" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-188">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-300 hover:text-white transition-colors" data-id="element-189">
                {link.name}
              </a>)}
          </nav>

          <div className="hidden md:block" data-id="element-190">
            <Button href="https://wa.me/56972115173?text=Hola%20Nacho%2C%20quiero%20mi%20web%20profesional" target="_blank" rel="noopener noreferrer" size="sm" icon={<MessageCircle className="w-4 h-4" data-id="element-192" />} data-id="element-191">
              Hablemos
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-slate-300 hover:text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-193">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-194" /> : <Menu className="w-6 h-6" data-id="element-195" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-brand-card border-b border-white/5 shadow-xl" data-id="element-196">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-197">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-slate-300 hover:text-white hover:bg-white/5 rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-198">
                {link.name}
              </a>)}
            <div className="pt-4 px-3" data-id="element-199">
              <Button href="https://wa.me/56972115173?text=Hola%20Nacho%2C%20quiero%20mi%20web%20profesional" target="_blank" rel="noopener noreferrer" className="w-full" icon={<MessageCircle className="w-5 h-5" data-id="element-201" />} data-id="element-200">
                Hablemos por WhatsApp
              </Button>
            </div>
          </div>
        </div>}
    </header>;
}